import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {RequisitionListService} from './requisition-list.service';
import {PaginationInstance} from 'ngx-pagination';
import {MstDepartmentService} from '../../configuration/mst-department/mst-department.service';

@Component({
    selector: 'app-requisition-list',
    templateUrl: './requisition-list.component.html',
    styleUrls: ['./requisition-list.component.css']
})
export class RequisitionListComponent implements OnInit {
    display:boolean=false;
    AddForm: FormGroup;
    ind:any;
    unitId:any;
    requisitionList:any;
    mstdepartmentlist:any;
    loading: boolean;
    formData: any = {}; // Object to store form data
    public config: PaginationInstance = {
        id: 'advanced',
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: 1
    };
    constructor( private formBuilder: FormBuilder,
                 private mstDepartmentService: MstDepartmentService,
                 private requisitionListService: RequisitionListService) {
    }

    ngOnInit() {

        this.unitId = sessionStorage.getItem('unitId');
        this.AddForm = this.formBuilder.group({
            requestBy: ['', Validators.required],
            subdepartment: ['', Validators.required],
            patientName: ['', Validators.required],
            mrNo: ['', Validators.required],
            gender: ['', Validators.required],
            bloodGroup: ['', Validators.required],
            request: ['', Validators.required],
            expectedDate: ['', Validators.required],
            expectedTime: ['', Validators.required]
        });
        this.getPage(1);
    }
    requisitiondialog(){
        this.display=true;
    }

    getPage(page: number) {

        if (page > 1) {
            this.ind = ((page - 1) * this.config.itemsPerPage) + 1;
        }else {
            this.ind = 1;
        }
        this.loading = true;
        this.requisitionListService.findAllRecordService().then(resp => {this.requisitionList = resp;});
        // this.mstIncidentmanagementService.getAllRecordService(page, this.config.itemsPerPage, '', '', '')
        //     .then(resp => {
        //         this.config.currentPage = page;
        //         this.config.totalItems = resp.totalElements;
        //         this.loading = false;
        // this.mstIncidentList = resp.content;
        // });
        this.mstDepartmentService.getlistbyunitService( this.unitId).then(resp1 => this.mstdepartmentlist = resp1);

    }


    openDialog() {
        this.display = true;
    }

    saveForm() {
        if (this.validateForm()) {
            // Call the service method to save the data
            this.requisitionListService.addRecordService(this.AddForm.value).then(
                response => {
                    console.log('Data saved successfully:', response);
                    this.clearForm();
                    this.closeDialog();
                },
                error => {
                    console.error('Error saving data:', error);
                    // Handle error if needed
                }
            );
        } else {
            alert('Please fill in all required fields.');
        }
    }

    cancel() {
        this.clearForm();
        this.closeDialog();
    }

    clearForm() {
        this.formData = {}; // Reset form data
    }

    closeDialog() {
        this.display = false; // Close the dialog
    }

    validateForm(): boolean {
        // Implement your form validation logic here
        return true; // Change this based on your validation logic
    }

}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/blood-transfusion/requisition-list/requisition-list.component.ts